<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="world-map">
<h1>World Map</h1>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:3.57525in;height:4.25911in"/></p><br/><br/>
<p style="text-align: center;"><img alt="" src="media/file1.jpg" style="width:4.68635in;height:5.29479in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?66f54679